module.exports = __webpack_public_path__ + "_/_/src/demo/src/catalog/items/column/column.png";


//////////////////
// WEBPACK FOOTER
// ./src/demo/src/catalog/items/column/column.png
// module id = 547
// module chunks = 0